module.exports = __webpack_public_path__ + "img/Reward_R_icon.404c55da.png";